import { Language } from '../../../enums/const-enums';

export interface RassPasswordTranslations {
  inputLabel: {
    default: string;
    otp: string;
  };
  buttonLabel: string;
  valueMissing: string;
  tooShort: string;
  tooLong: string;
}

const nlTranslations: RassPasswordTranslations = {
  inputLabel: {
    default: 'Wachtwoord',
    otp: 'Eenmalig wachtwoord',
  },
  buttonLabel: 'Inloggen',
  valueMissing: 'Wachtwoord is verplicht.',
  tooShort: 'Minimaal 8 karakters.',
  tooLong: 'Maximaal 64 karakters.',
};

const enTranslations: RassPasswordTranslations = {
  inputLabel: {
    default: 'Password',
    otp: 'One-time password',
  },
  buttonLabel: 'Login',
  valueMissing: 'Password is required.',
  tooShort: 'Minimum 8 characters.',
  tooLong: 'Maximum 64 characters.',
};

const esTranslations: RassPasswordTranslations = {
  inputLabel: {
    default: 'Contraseña',
    otp: 'Contraseña de un solo uso',
  },
  buttonLabel: 'Iniciar sesión',
  valueMissing: 'Contraseña es requerido.',
  tooShort: 'Minimum 8 characters.',
  tooLong: 'Maximum 64 characters.',
};

const ptTranslations: RassPasswordTranslations = {
  inputLabel: {
    default: 'Senha',
    otp: 'Senha válida para um único acesso',
  },
  buttonLabel: 'Entrar',
  valueMissing: 'Senha é obrigatório.',
  tooShort: 'Minimum 8 characters.',
  tooLong: 'Maximum 64 characters.',
};

export const rassPasswordTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: esTranslations,
  [Language.PT]: ptTranslations,
};
